function pageWindow(current: number, pages: number): number[] {
  const end = Math.min(pages, Math.max(current + 2, 5))
  const start = Math.max(1, end - 4)
  const numbers: number[] = []
  for (let page = start; page <= Math.min(pages, start + 4); page += 1) numbers.push(page)
  return numbers
}

export function ResultsPager({
  page,
  pageSize,
  total,
  onPage,
}: {
  page: number
  pageSize: number
  total: number
  onPage: (page: number) => void
}) {
  const pages = Math.max(1, Math.ceil(total / pageSize))
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1
  const to = Math.min(page * pageSize, total)
  const numbers = pages <= 7 ? Array.from({ length: pages }, (_, index) => index + 1) : pageWindow(page, pages)

  return (
    <div className="results-pager">
      {pages > 1 && (
        <nav aria-label="results pages">
          <ul className="pagination mb-2">
            <li className={`page-item ${page <= 1 ? 'disabled' : ''}`}>
              <button type="button" className="page-link" aria-label="Previous page" disabled={page <= 1} onClick={() => onPage(page - 1)}>&lt;&lt;</button>
            </li>
            {numbers[0] > 1 && (
              <li className="page-item">
                <button type="button" className="page-link" onClick={() => onPage(1)}>1</button>
              </li>
            )}
            {numbers.map((number) => (
              <li className="page-item" key={number}>
                <button type="button" className="page-link" aria-label={`Page ${number}`} aria-current={number === page ? 'page' : undefined} onClick={() => onPage(number)}>
                  <span className={number === page ? 'fw-bold' : undefined}>{number}</span>
                </button>
              </li>
            ))}
            {numbers[numbers.length - 1] < pages && (
              <li className="page-item">
                <button type="button" className="page-link" onClick={() => onPage(pages)}>{pages}</button>
              </li>
            )}
            <li className={`page-item ${page >= pages ? 'disabled' : ''}`}>
              <button type="button" className="page-link" aria-label="Next page" disabled={page >= pages} onClick={() => onPage(page + 1)}>&gt;&gt;</button>
            </li>
          </ul>
        </nav>
      )}
      <div>Showing <b>{from}</b> to <b>{to}</b> Total: <b>{total}</b></div>
    </div>
  )
}
